import { commonFilter } from './filter';

const pageId = '20120';

export default {
  pageName: 'Genre Creator List',
  pageId: pageId,
  pagePath: '/opinion/Influencer/GenreCreatorList',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
